export default __webpack_public_path__ + "static/media/circleCloud4.2d03eaee.webp";